import { render, staticRenderFns } from "./CompanyQWindow.vue?vue&type=template&id=354d53f8&"
import script from "./CompanyQWindow.vue?vue&type=script&lang=js&"
export * from "./CompanyQWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports